/**
 * S4CA's apps, for the switcher in the header (AppSwitcher in App.jsx).
 *
 * The same list is kept in InfoCodes (s4caFileMaker, src/app/lib/suite.js): adding an
 * app means an entry in both, and in the new app's own copy, with each app's mark
 * copied into the others' public/suite/. The marks are served from this app's own
 * origin rather than fetched from the other's, because each app sits behind its own
 * Access application and a cross-origin request for an image would get the sign-in
 * page back instead.
 *
 * Every mark is white artwork on transparency, drawn over the brand colour as the
 * sidebar's own mark is (.nav-logo); `size` is how much of the tile it fills.
 */
export const HERE = 'news'

export const SUITE = [
  {
    key: 'news',
    name: 'S4CA News',
    blurb: 'Newsletters, updates and partner units',
    href: 'https://s4narchive.com/',
    mark: '/icon-mark.png?v=7',
    size: '77.4%',
  },
  {
    key: 'infocodes',
    name: 'S4CA InfoCodes',
    blurb: 'Households, file codes, transfers and screening',
    href: 'https://s4cafilemaker.apps-93f.workers.dev/',
    mark: '/suite/infocodes-mark.png?v=1',
    size: '74%',
  },
  {
    key: 's4cinfo',
    name: 'S4CA Info',
    blurb: 'Member care: contacts, documents and crisis information',
    href: 'https://app.s4cinfo.com/',
    mark: '/suite/s4cinfo-mark.svg?v=1',
    size: '62%',
  },
]
